import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import CheckerAudioPlayer from "../components/testPage/CheckerAudioPlayer";
import "../styles/common/roots.css";

const TestPage = () => {
  const location = useLocation();
  const {
    groups,
    displayTitle,
    wpm,
    individual_lesson_id,
    userId,
    fromPracticePage,
  } = location.state;

  // Ensure the page starts from the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Change displayTitle to "COMBINED" if its length is greater than 5
  const title = displayTitle.length > 5 ? "COMBINED" : displayTitle;

  // Check if 'groups' is an array; if not, try to parse it as a stringified JSON array
  let parsedGroups = groups;
  if (!Array.isArray(groups)) {
    try {
      // Parse groups if it's a stringified JSON array
      parsedGroups = JSON.parse(groups);
    } catch (error) {
      console.error("Error parsing groups as JSON:", error);
    }
  }

  // Join the parsedGroups if it's an array
  console.log("Answers: ", parsedGroups.join(""));

  return (
    <div>
      <Navbar />
      <div className="container-fluid mx-lg-5">
        <CheckerAudioPlayer
          selectedLetters={title}
          checkerGroups={parsedGroups.join("")}
          audioGroups={parsedGroups}
          wpm={wpm}
          lessonId={individual_lesson_id}
          userId={userId}
          fromPracticePage={fromPracticePage}
        />
      </div>
    </div>
  );
};

export default TestPage;
